export default "__VITE_ASSET__emHQgNc4__"